// extracted by mini-css-extract-plugin
export default {"gpt3__cta":"cta_gpt3__cta__-AQNg","gpt3__cta-content":"cta_gpt3__cta-content__N1c5V","gpt3__cta-btn":"cta_gpt3__cta-btn__PlhMp"};